import MainLayout from "@/components/layout/admin/MainLayout.vue";
import store from "@/store";
import axios from "axios";
import { required, maxLength } from "vuelidate/lib/validators";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

const GRADING_SETTING_DESCRIPTION_MAX = 1000;

export default {
  name: "GradingSettingCreate",
  components: {
    MainLayout,
    Loading,
  },

  data() {
    return {
      isLoading: false,
      submitted: false,
      disabled: false,
      campus_name: store.state.user.campus_master.campus_name,
      settingData: {
        name: "",
        description: "",
        login_id: store.state.user.id,
      },
    };
  },

  validations: {
    settingData: {
      name: {
        required,
        maxLength: maxLength(255),
      },
      description: {
        maxLength: maxLength(GRADING_SETTING_DESCRIPTION_MAX),
      },
    },
  },

  methods: {
    create() {
      this.submitted = true;
      if (this.$v.$invalid) {
        return;
      }
      this.disabled = true;
      this.isLoading = true;
      axios
        .post("gradingSetting/create", this.settingData)
        .then((res) => {
          if (res.data.success == true) {
            this.$notification.success("Grading Setting Added Successfully", {
              timer: 3,
              position: "bottomCenter",
            });
            this.$router.push({ name: "gradingSettingList" });
          } else {
            this.$notification.error(res.data.message || "Create failed", {
              timer: 3,
              position: "bottomCenter",
            });
            this.disabled = false;
            this.isLoading = false;
          }
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit("logout");
            window.location.replace("login");
          }
          const msg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "Create failed";
          this.$notification.error(msg, {
            timer: 3,
            position: "bottomCenter",
          });
          this.disabled = false;
          this.isLoading = false;
        });
    },

    showList() {
      this.$router.push({ name: "gradingSettingList" });
    },
  },
};
